export const sliderOptionFormat = {
    getSliderIndex(currentSliderPointer, optCount, stepWidth) {
        let valIndex = Math.floor(currentSliderPointer / stepWidth);
        if (valIndex >= optCount) {
            valIndex = optCount - 1;
        }

        return valIndex;
    },
    setRangeSlider(fromElement, toElement, minimumValue, maximumValue, rangeElement, unit, isFormateInput) {
        const isFormate = isFormateInput || false;
        let minVal = Translations.no_lower_limit;
        let maxVal = Translations.no_upper_limit;
        if (fromElement.val() && parseInt(fromElement.val(), 10) !== minimumValue) {
            let fromValue = isFormate ? commonUtils.number_format(fromElement.val(), 0, ',', ' ') : fromElement.val();
            minVal = `<span>${fromValue}</span> <span>${unit}</span>`;
        } else {
            fromElement.val('');
        }

        if (toElement.val() && parseInt(toElement.val(), 10) !== maximumValue) {
            let toValue = isFormate ? commonUtils.number_format(toElement.val(), 0, ',', ' ') : toElement.val();
            maxVal = `<span>${toValue}</span> <span>${unit}</span>`;
        } else {
            toElement.val('');
        }

        $(`#${rangeElement}`).html(`${minVal} - ${maxVal}`);
    },
    getClosestOption(list, value) {
        return list.reduce(function (prev, curr) {
            // Get the closest value from given array of list
            return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
        });
    },
    validateRange(element, sliderObject, isSliderExist = true) {
        let allowMinimumValue = sliderObject.list[0];
        let allowMaximumValue = sliderObject.list[sliderObject.list.length - 1];
        let { fromElement } = sliderObject;
        let { toElement } = sliderObject;
        let elementName = element.attr('name');
        let value = parseInt(element.val(), 10);

        // Validate if the value is within the allowed range
        if (value < allowMinimumValue || value > allowMaximumValue) {
            alert(
                Translations.advanced_search.invalid_range_value
                    .replace('%min%', allowMinimumValue)
                    .replace('%max%', allowMaximumValue)
            );
            element.val('').focus();
        } else if (elementName === fromElement.attr('name') && value > parseInt(toElement.val(), 10)) {
            alert(Translations.advanced_search.invalid_minimum_value);
            element.val('').focus();
        } else if (elementName === toElement.attr('name') && value < parseInt(fromElement.val(), 10)) {
            alert(Translations.advanced_search.invalid_maximum_value);
            element.val('').focus();
        }

        // Reset slider values
        if (isSliderExist) {
            if (elementName === fromElement.attr('name')) {
                sliderObject.setSlider(element.val(), toElement.val());
            } else {
                sliderObject.setSlider(fromElement.val(), element.val());
            }
        }
    },
};
